import { OrganizeModel } from "@/models/classes/organize";
import { AuthApi } from "./api/auth";
import { plainToClassFromExist } from "class-transformer";
import { ResponseModel } from "@/models/classes/response";
import { UserModel, SaleOrgModel } from "@/models/classes/user";
import { SuccessModel } from "@/models/classes/success";
import { MenuCallPlanItem } from "@/models/classes/plan/visit";
import { CenterModel } from "@/models/classes/organize/center";

const api = new AuthApi();
export class AuthService {
  getUser = async () => {
    const resOrgData = await api.getCurrentSaleOrg();
    const resData = await api.getUser();

    const resModel = plainToClassFromExist(new ResponseModel<UserModel>(UserModel), resData);

    const resOrgModel = plainToClassFromExist(new ResponseModel<SaleOrgModel>(SaleOrgModel), resOrgData);

    if (resModel.status == 200 && typeof resModel.data == "object") {
      return { user: resModel.data, saleOrg: resOrgModel.data };
    }
    return undefined;
  };

  fetchOrganize = async (company?: string | null, channel?: string | null, saleOrg?: string | null) => {
    const resData = await api.fetchOrganize(company, channel, saleOrg);
    const resModel = plainToClassFromExist(new ResponseModel<OrganizeModel>(OrganizeModel), resData);
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return {
        data: resModel.data,
        selectedIndex: resData?.selectedIndex,
        selectedValue: resData?.selectedValue,
      };
    }
    return undefined;
  };

  updateOrganize = async (company: string, channel: string, saleOrg: number, center: number) => {
    const resData = await api.updateOrganize(company, channel, saleOrg, center);
    const resModel = plainToClassFromExist(new ResponseModel<SuccessModel>(SuccessModel), resData);
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return resModel.data;
    }
    return false;
  };

  fetchSaleOrgCenter = async (params: { SaleOrgCriteriaId: number }) => {
    const resData = await api.getSaleOrgCenter(params);
    const resModel = plainToClassFromExist(new ResponseModel<SuccessModel>(CenterModel), resData);
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return resModel.data;
    }
    return undefined;
  };

  fetchMenuCallPlan = async (params: any = {}) => {
    const resData = await api.getMenuCallPlan(params); //MenuCallPlan
    const resModel = plainToClassFromExist(new ResponseModel<MenuCallPlanItem[]>(MenuCallPlanItem), resData);
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return resModel.data;
    }
    return undefined;
  };

  fetchMenuTakeOrder = async (params: any = {}) => {
    const resData = await api.getMenuTakeOrder(params); //MenuCallPlan
    const resModel = plainToClassFromExist(new ResponseModel<MenuCallPlanItem[]>(MenuCallPlanItem), resData);
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return resModel.data;
    }
    return undefined;
  };

    fetchMenuPermission = async (params: { type: string }) => {
    const resData = await api.getMenuPermission(params);
    const resModel = plainToClassFromExist(new ResponseModel<MenuCallPlanItem[]>(MenuCallPlanItem), resData);
    if (resModel.status == 200 && typeof resModel.data == "object") {
      return resModel.data;
    }
    return undefined;
  };
}
